export default {
  DRIVETRAIN: "Motricité",

  DRIVETRAIN_AWD: "Transmission intégrale",
  DRIVETRAIN_4WD: "Quatre roues motrices",
  DRIVETRAIN_FWD: "Traction avant",
  DRIVETRAIN_RWD: "Traction arrière",
};
